import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let FeedbackAdminFeature = /*#__PURE__*/(() => {
  let FeedbackAdminFeature = class FeedbackAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/feedback/frontend-admin","featureId":"common-feedback"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Feedback',
          priority: 1,
          routerLink: 'feedback',
          icon: 'comments'
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵFeedbackAdminFeature_BaseFactory;
        return function FeedbackAdminFeature_Factory(__ngFactoryType__) {
          return (ɵFeedbackAdminFeature_BaseFactory || (ɵFeedbackAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(FeedbackAdminFeature)))(__ngFactoryType__ || FeedbackAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: FeedbackAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'feedback',
          loadChildren: () => import('./feedback-admin.module').then(m => m.FeedbackAdminModule)
        }])]
      });
    }
  };
  FeedbackAdminFeature = __decorate([ClassName("FeedbackAdminFeature")], FeedbackAdminFeature);
  return FeedbackAdminFeature;
})();
export { FeedbackAdminFeature };